import React, { FC } from "react";
import { InputPicker, Tags } from "@shared/components";
import { DropDown, Tag as TagInterface } from "@shared/interfaces";
import "./index.scss";

export type TaggedInputPickerProps = {
  title?: string;
  placeholder?: string;
  emptyResultsText?: string;
  data: DropDown[];
  tags: TagInterface[];
  disabledValues?: string[];
  selectAll?: boolean;
  values: string[];
  onChange: (value: string) => void;
  onTagRemove: (tag: TagInterface["value"]) => void;
  groupBy?: string;
  onClearAll?: () => void;
};

const TaggedInputPicker: FC<TaggedInputPickerProps> = (props) => {
  const {
    title,
    data,
    onChange,
    onTagRemove,
    tags,
    values,
    disabledValues,
    selectAll,
    placeholder = "Select",
    emptyResultsText = "No matches",
    groupBy,
    onClearAll,
  } = props;

  return (
    <div className="select-line">
      <div className="form-select">
        {title && <h5 className="input-title">{title}</h5>}
        <InputPicker
          creatable={false}
          cleanable={false}
          searchable={true}
          selectAll={selectAll}
          name="product-type"
          locale={{ noResultsText: emptyResultsText }}
          useContainer={true}
          disableContainerStyles={true}
          className="select-picker"
          data={data}
          disabledItemValues={disabledValues ?? []}
          placeholder={placeholder}
          onChange={onChange}
          value={values}
          groupBy={groupBy}
        />
      </div>
      <Tags tags={tags} onTagRemove={onTagRemove} onClearAll={onClearAll} />
    </div>
  );
};

export default TaggedInputPicker;
